import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState, AppThunk } from '../app/store';
import { fetchCount } from '../api/counterAPI';
import { postRequest } from '../app/postRequest.service';
import { LoginRequest, LoginResponse } from '../interfaces/login';
import { loginApi } from '../api/loginAPI';
import { ConfigResponse } from '../interfaces/config.interface';
import { configApi } from '../api/homeAPI';
import { PolicyDocumentsResponse } from '../interfaces/policyDocuments.interface';
import { policyDocumentsApi } from '../api/policyAPI';

export interface PolicyState {
  value: PolicyDocumentsResponse | null;
  status: 'idle' | 'loading' | 'failed';
}

const initialState: PolicyState = {
  value: null,
  status: 'idle',
};

export const policyAsync = createAsyncThunk(
  'policy/policyAsync',
  async () => {
    const response = await policyDocumentsApi()
    return response.data;
  }
);

export const policySlice = createSlice({
  name: 'policy',
  initialState,
  
  reducers: {
    // increment: (state) => { 
    //   state.value += 1;
    // },
    // decrement: (state) => {
    //   state.value -= 1;
    // },
    
    // incrementByAmount: (state, action: PayloadAction<number>) => {
    //   state.value += action.payload;
    // },
  },
  
  
  extraReducers: (builder) => {
    builder
      .addCase(policyAsync.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(policyAsync.fulfilled, (state, action) => {
        state.status = 'idle';
        state.value = action.payload;
      })
      .addCase(policyAsync.rejected, (state) => {
        state.status = 'failed';
      });
  },
});

export const { } = policySlice.actions;
export const getPolicyDocuments = (state: RootState) => state.policyDocuments.value;

export default policySlice.reducer;
